import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@wove/web-ui'
import { useState, useRef, useEffect } from 'react'

interface AutoWidthSelectProps {
  value: string
  onValueChange: (value: string) => void
  options: Array<{ value: string; label: string }>
  placeholder?: string
  className?: string
}

export default function AutoWidthSelect({ 
  value, 
  onValueChange, 
  options, 
  placeholder,
  className = ''
}: AutoWidthSelectProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [width, setWidth] = useState('auto')
  const measureRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    if (measureRef.current && value) {
      const selectedOption = options.find(opt => opt.value === value)
      if (selectedOption) {
        measureRef.current.textContent = selectedOption.label
        const measuredWidth = measureRef.current.offsetWidth + 32 // Add padding for arrow
        setWidth(`${measuredWidth}px`)
      }
    }
  }, [value, options])

  return (
    <>
      <span 
        ref={measureRef} 
        className="absolute invisible whitespace-nowrap text-sm"
        style={{ visibility: 'hidden', position: 'absolute' }}
      />
      <Select 
        value={value} 
        onValueChange={onValueChange}
        onOpenChange={setIsOpen}
      >
        <SelectTrigger 
          className={className}
          style={{ width: isOpen ? undefined : width, minWidth: isOpen ? '80px' : undefined }}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </>
  )
}